import * as yup from "yup";
import { useLocalStorageState } from "ahooks";
import { isFunction } from "lodash-es";

export const useValidatedLocalStorage = <T>(
  key: string,
  defaultValue: T | (() => T),
  schema: yup.Schema<T>,
) => {
  return useLocalStorageState<T>(key, {
    defaultValue,
    listenStorageChange: true,
    deserializer: (value) => {
      try {
        const parsed = JSON.parse(value);
        return schema.validateSync(parsed);
      } catch {
        return isFunction(defaultValue) ? defaultValue() : defaultValue;
      }
    },
    serializer: JSON.stringify,
  });
};
